module.exports = __webpack_public_path__ + "img/product_72.4496ecc.webp";